<div class="bil-container">
    <router-outlet></router-outlet>
</div>

<div class="bil-loading-screen" style="visibility: hidden;">
    <div class="bil-bouncing-loader">
        <img class="bil-bouncing-image" src="assets/logo-mark-small.svg" />
    </div>
</div>